// Picker queries return a capped list and search reaches older rows, so the grid scrolls instead of paging.
export const PICKER_GRID_HEIGHT = 200;

export const PICKER_GRID_DENSITY = {
  columnHeaderHeight: 40,
  rowHeight: 32,
  hideFooter: true,
  // The wrapper defaults this on for checkbox grids; it is pagination-only.
  checkboxSelectionVisibleOnly: false,
};
